// src/firebase/comments.js
import { 
    getFirestore, 
    collection, 
    addDoc, 
    deleteDoc, 
    doc, 
    query, 
    orderBy, 
    onSnapshot,
    serverTimestamp 
  } from 'firebase/firestore';
  import { initializeApp } from 'firebase/app';
  import firebaseConfig from './config';
  
  // Initialize Firebase if not already initialized
  let app;
  try {
    app = initializeApp(firebaseConfig);
  } catch (e) {
    // App already initialized
  }
  
  const db = getFirestore();
  const COMMENTS_COLLECTION = 'examContentDiscussions';
  
  // Add a comment or citation to Firestore
  export const addComment = async (commentData) => {
    try {
      const docRef = await addDoc(collection(db, COMMENTS_COLLECTION), {
        ...commentData,
        createdAt: serverTimestamp(),
        appSource: 'exam-content',
        platform: 'cosknow'
      });
      return { id: docRef.id, ...commentData };
    } catch (error) {
      console.error("Error adding comment:", error);
      throw error;
    }
  };
  
  // Delete a comment or citation from Firestore
  export const deleteComment = async (commentId) => {
    try {
      const commentRef = doc(db, COMMENTS_COLLECTION, commentId);
      await deleteDoc(commentRef);
      return true;
    } catch (error) {
      console.error("Error deleting comment:", error);
      throw error;
    }
  };
  
  // Set up real-time listener for comments
  export const subscribeToComments = (callback) => {
    try {
      const commentsQuery = query(
        collection(db, COMMENTS_COLLECTION),
        orderBy('createdAt', 'desc')
      );
      
      return onSnapshot(commentsQuery, (snapshot) => {
        const comments = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          const timestamp = data.createdAt ? data.createdAt.toDate().toISOString() : new Date().toISOString();
          
          comments.push({
            id: doc.id,
            ...data,
            timestamp
          });
        });
        
        callback(comments);
      }, (error) => {
        console.error("Error in comments listener:", error);
        callback([]);
      });
    } catch (error) {
      console.error("Error setting up comments subscription:", error);
      return () => {}; // Return empty function if subscription fails
    }
  };